import type { QRFrameProps } from './types';

export function QRFrame({ children }: QRFrameProps) {
  return (
    <div className="relative w-[250px] h-[250px] mx-auto" data-name="QR 인식">
      {children}
      <div className="absolute inset-[-0.4%] pointer-events-none text-primary">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 250 250">
          <g id="QR 인식">
            <path
              d="M67.2629 1H1V65.2"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              className="animate-pulse"
            />
            <path
              d="M182.737 1H249V65.2"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              className="animate-pulse"
            />
            <path
              d="M67.2629 248.363H1V182.718"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              className="animate-pulse"
            />
            <path
              d="M182.737 248.363H249V182.718"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              className="animate-pulse"
            />
          </g>
        </svg>
      </div>
    </div>
  );
}
